import PackageIndex from '@/views/layanan/paket/PackageIndex.vue';
import PackageForm from '@/views/layanan/paket/PackageForm.vue';
import PackagePreview from '@/views/layanan/paket/PackagePreview.vue';
import PackageProgram from '@/views/layanan/paket/program/ProgramForm.vue';
import PackageDetail from '@/views/layanan/paket/PackageDetail.vue';

const packages = [
        {
            path: '/packages',
            name: 'package',
            component: PackageIndex,
                        meta: {
                    requiresAuth: true,
                    roles: ['Super Admin', 'Admin Office'], 
                },
        },
        {
            path: '/packages/add',
            name: 'packageAdd',
            component: PackageForm,
            meta: {
                requiresAuth: true,
                roles: ['Super Admin', 'Admin Office'], 
            },
        },
        {
            path: '/packages/edit/:uuid',
            name: 'packageEdit',
            component: PackageForm,
            meta: {
                requiresAuth: true,
                roles: ['Super Admin', 'Admin Office'], 
            },
        },
        {
            path: '/packages/detail/:uuid',
            name: 'packageDetail',
            component: PackageDetail,
            meta: {
                requiresAuth: true,
                roles: ['Super Admin', 'Admin Office'], 
            },
        },
        {
            path: '/packages/preview/:uuid',
            name: 'packagePreview',
            component: PackagePreview,
            meta: {
                requiresAuth: true,
                roles: ['Super Admin', 'Admin Office'], 
            },
        },
        {
            path: '/packages/program/:uuid',
            name: 'packageProgram',
            component: PackageProgram,
            meta: {
                requiresAuth: true,
                roles: ['Super Admin', 'Admin Office'], 
            },
        }
]

export default packages